import { useState, useEffect } from 'react';
import { Form, Input, Button, message, Collapse, Space } from 'antd';
import { PlusOutlined, MinusCircleOutlined } from '@ant-design/icons';
import API from '../api/client';

const { Panel } = Collapse;

const FooterPage = () => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    API.get('/footer').then((res) => {
      if (res.data && res.data._id) form.setFieldsValue(res.data);
    });
  }, [form]);

  const handleSave = async () => {
    setLoading(true);
    try {
      const values = await form.validateFields();
      await API.put('/footer', values);
      message.success('Kaydedildi');
    } catch {
      message.error('Hata oluştu');
    }
    setLoading(false);
  };

  const linkFields = (name, addLabel) => (
    <Form.List name={name}>
      {(fields, { add, remove }) => (
        <>
          {fields.map(({ key, name: fieldName, ...rest }) => (
            <Space key={key} align="baseline" style={{ display: 'flex', marginBottom: 8 }}>
              <Form.Item {...rest} name={[fieldName, 'label']} rules={[{ required: true, message: 'Başlık girin' }]}>
                <Input placeholder="Başlık" style={{ width: 200 }} />
              </Form.Item>
              <Form.Item {...rest} name={[fieldName, 'url']} rules={[{ required: true, message: 'URL girin' }]}>
                <Input placeholder="/sayfa-yolu veya #" style={{ width: 250 }} />
              </Form.Item>
              <MinusCircleOutlined onClick={() => remove(fieldName)} style={{ color: '#ff4d4f' }} />
            </Space>
          ))}
          <Button type="dashed" onClick={() => add()} icon={<PlusOutlined />} style={{ width: '100%' }}>
            {addLabel}
          </Button>
        </>
      )}
    </Form.List>
  );

  return (
    <>
      <h2>Footer Ayarları</h2>
      <Form form={form} layout="vertical" style={{ maxWidth: 700 }}>
        <Collapse defaultActiveKey={['1', '2', '3', '4']} style={{ marginBottom: 24 }}>
          <Panel header="Hakkımızda Metni" key="1">
            <Form.Item name="aboutText" label="Footer Açıklama Metni">
              <Input.TextArea rows={3} placeholder="Footer'da görünecek kısa açıklama metni" />
            </Form.Item>
          </Panel>

          <Panel header="Hızlı Linkler" key="2">
            <p style={{ color: '#888', marginBottom: 16, fontSize: 13 }}>
              Header menüsüyle aynı sayfaları ekleyin. URL'ler site içi yol olmalıdır (ör: /hakkimizda, /duyurular).
            </p>
            {linkFields('quickLinks', 'Hızlı Link Ekle')}
          </Panel>

          <Panel header="İşletmelerimiz" key="3">
            <p style={{ color: '#888', marginBottom: 16, fontSize: 13 }}>
              İşletme linkleri. Henüz sayfası yoksa URL olarak # kullanabilirsiniz.
            </p>
            {linkFields('businessLinks', 'İşletme Linki Ekle')}
          </Panel>

          <Panel header="Alt Bilgi" key="4">
            <Form.Item name="copyright" label="Telif Hakkı Metni">
              <Input placeholder="© 2026 Dihiz Turizm Organizasyon & Restoran. Tüm hakları saklıdır." />
            </Form.Item>
            <Form.Item name="subtitle" label="Alt Metin">
              <Input placeholder="Didim Belediyesi İştiraki" />
            </Form.Item>
          </Panel>
        </Collapse>

        <Button type="primary" onClick={handleSave} loading={loading} size="large">
          Kaydet
        </Button>
      </Form>
    </>
  );
};

export default FooterPage;
